module.exports = __webpack_public_path__ + "static/media/24UHCHR19.984a5d4f.jpg";